"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _framerMotion = require("framer-motion");
var _HBAccordionDetails = _interopRequireDefault(require("./HBAccordionDetails"));
var _HBAccordionSummary = _interopRequireDefault(require("./HBAccordionSummary"));
var _HBAccordion = require("./HBAccordion.styles");
var HBAccordion = function HBAccordion(_ref) {
  var children = _ref.children,
    _ref$expandedId = _ref.expandedId,
    expandedId = _ref$expandedId === void 0 ? '' : _ref$expandedId,
    onClick = _ref.onClick,
    collapseIcon = _ref.collapseIcon,
    expandedIcon = _ref.expandedIcon,
    _ref$theme = _ref.theme,
    theme = _ref$theme === void 0 ? 'regular' : _ref$theme,
    _ref$enableInitialAni = _ref.enableInitialAnimation,
    enableInitialAnimation = _ref$enableInitialAni === void 0 ? false : _ref$enableInitialAni;
  var toggle = function toggle(id) {
    return onClick(id);
  };
  return /*#__PURE__*/_react["default"].createElement(_HBAccordion.Accordion, null, _react["default"].Children.map(children, function (child) {
    var id = child.props.children[0].props.id;
    var isExpanded = expandedId === id;
    var summaryItem = /*#__PURE__*/_react["default"].cloneElement(child.props.children[0], {
      toggle: toggle,
      isExpanded: isExpanded,
      collapseIcon: collapseIcon,
      expandedIcon: expandedIcon
    });
    return /*#__PURE__*/_react["default"].createElement(_HBAccordion.AccordionItem, {
      theme: theme
    }, summaryItem, /*#__PURE__*/_react["default"].createElement(_framerMotion.AnimatePresence, {
      initial: enableInitialAnimation
    }, isExpanded && child.props.children[1]));
  }));
};
HBAccordion.Summary = _HBAccordionSummary["default"];
HBAccordion.Details = _HBAccordionDetails["default"];
HBAccordion.Item = function (_ref2) {
  var children = _ref2.children;
  return children;
};
var _default = exports["default"] = HBAccordion;
//# sourceMappingURL=HBAccordion.js.map